import SelfLock from "../../views/Self/SelfLock";
import {useTranslation} from "../../contexts/Localization";
import {ButtonMenuItem} from "../../uikit";
import {useState} from "react";
import SelfLockToken from "../../views/Self/SelfLockToken";
import SelfLockLp from "../../views/Self/SelfLockLp";

const SelfLockPage = () => {
  const { t } = useTranslation()

  const [index,setIndex] = useState(0);


  return <div style={{display:'flex',flexDirection:'column',alignItems:'center'}}>
    <div style={{marginTop:20}}></div>
    <div style={{display:'flex',flexDirection:'row'}}>
      <ButtonMenuItem onClick={()=>setIndex(0)} style={{boxShadow:'none',color:index==0?'#E7BB4B':'#ffffff'}} id="swap-nav-link" as="a">
        {t('Create Lock')}
      </ButtonMenuItem>
      <ButtonMenuItem onClick={()=>setIndex(1)} style={{boxShadow:'none',color:index==1?'#E7BB4B':'#ffffff'}} id="swap-nav-link" as="a">
        {t('Tokens')}
      </ButtonMenuItem>
      <ButtonMenuItem onClick={()=>setIndex(2)} style={{boxShadow:'none',color:index==2?'#E7BB4B':'#ffffff'}} id="swap-nav-link" as="a">
        {t('Liquidity')}
      </ButtonMenuItem>
    </div>
    {index == 0? <SelfLock />:index ==1?<SelfLockToken/>:<SelfLockLp/>}
  </div>
}

export default SelfLockPage
